import { ReportParameter } from './report-parameter.model';

export class ParameterRow {
    Parameters: ReportParameter[] = [];
    HasParameterInGroup: boolean;
    IncludeGroupLabel: boolean;
    Group_ID: number;
    MaxNumberOfParameters: number;
    Colspan: number;
    GroupLabel: string;
    IncludeLineAtStartOfGroup: boolean;
    IncludeLineAtEndOfGroup: boolean;
    AlreadyCheckedForGroupStart: boolean;
    AlreadyCheckedForGroupEnd: boolean;
    IsStartOfVisibleGroup: boolean;
    IsEndOfVisibleGroup: boolean;

    // constructor(parameters: ReportParameter[]) {
    //     this.Parameters = parameters;
    // }
}




    // RowNumber: number;
    // ParameterIds: number[] = [];
    // NumberOfColumns: number;
